import t from"styled-components";const i=t.div`
	display: flex;
	position: absolute;
	overflow: hidden;
	top: 0;
	bottom: 0;
	justify-content: ${({position:t})=>"left"===t?"end":"start"};
	width: ${({width:t,isOpen:i})=>i?t:0}px;
	${({position:t})=>t}: 0;
	background: ${({theme:t})=>t.bg.general};
	z-index: 10;
	border-left: 1px solid ${({theme:t})=>t.border.black10};
	box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.12);
	transition: visibility 0.1s, width 0.2s;
`,e=t.div`
	box-sizing: border-box;
	height: 100%;
	padding: 20px;
	min-width: ${({width:t})=>t}px;
`,o=t.div`
	height: 100%;
`,s=t.div`
	display: flex;
	position: relative;
	justify-content: space-between;
	margin-bottom: 15px;
	font-size: 14px;
	font-weight: 400;

	${({showTabs:t})=>t?`border-bottom: 2px solid ${({theme:t})=>t.border.black15}`:""}
`,d=t.div`
	cursor: pointer;
	border-radius: 50%;
	position: fixed;
	height: 23px;
	width: 23px;
	margin-left: -32px;
	background: ${({color:t})=>t};
	box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);

	&:hover {
		filter: brightness(0.97);
	}
`,r=t.div`
	display: flex;
	column-gap: 15px;
	font-size: 14px;
	margin-bottom: -2px;
`,n=t.span`
	opacity: ${({isSelected:t,isDisabled:i})=>t?1:i?.2:.5};
	color: ${({theme:t})=>t.text.title};
	border-bottom: ${({isSelected:t,theme:i})=>`2px solid ${t?i.text.title:"transparent"}`};
	cursor: ${({isDisabled:t})=>t?"initial":"pointer"};
	user-select: none;
	padding-bottom: 6px;
`;export{d as CloseIcon,s as Header,o as ScrollbarWrapper,e as Sidebar,i as SidebarContainer,r as SimpleTabs,n as Tab};
